import { apiHost } from '@/env'
export default {
  // dingHost
  // 钉钉授权 免登
  API_DING_TOKEN: `${apiHost}/ding/getJsAuth`,
  // 获取免登用户信息
  API_DING_USER_INFO: `${apiHost}/ding/corpUser/getLoginUserInfo`,
  // 删除机构成员人员数据
  API_DING_USER_REMOVW_FACE: `${apiHost}/ding/corpUser/removeUserFace`,
  // 查询人员详情
  API_DING_MEMBER_INFO: `${apiHost}/member/info`,
  // 同步通讯录
  API_DING_START_USER_SYNC: `${apiHost}/ding/corp/startUserSync`,
  // 钉钉Id转化为部门Id
  API_DING_TRANSFORM_DEPT: `${apiHost}/dept/getTpIdDeptIdRelation`,
  // 部门Id转化未钉钉Id
  API_DING_TRANSFORM_TPDEPT: `${apiHost}/dept/getDeptIdTpIdRelation`,
  // 查询学生基本信息
  API_DING_STUDENT_BASE_INFO: `${apiHost}/ding/corp/school/getStudentBaseInfo`,
  // 查询学生信息
  API_DING_STUDENT_INFO: `${apiHost}/ding/corp/school/getStudentDetail`,
  // 查询老师信息
  API_DING_TEACHER_INFO: `${apiHost}/ding/corp/school/getTeacherList`,
  // 查询校区信息(列表)
  API_DING_CAPMUS_LIST: `${apiHost}/ding/corp/school/getCapmusList`,
  // 查询学段信息(列表)
  API_DING_PERIOD_LIST: `${apiHost}/ding/corp/school/getPeriodList`,
  // 查询年级信息(列表)
  API_DING_GRADE_LIST: `${apiHost}/ding/corp/school/getGradeList`,
  // 查询班级信息(列表)(分页)
  API_DING_CLASS_LIST: `${apiHost}/ding/corp/school/getPaginationClassList`,
  // 查询学生信息(列表)(分页)
  API_DING_STUDENT_LIST: `${apiHost}/ding/corp/school/getPaginationStudentList`,
  // 学生按名字搜索-分校区(分页)
  API_DING_SEATRCH_STUDENT_LIST: `${apiHost}/ding/corp/school/searchStudentList`,

  // fishnetHost
  // 上传临时图片
  API_FISHNET_UPLOAD_TEMP_PIC_BY_BINARY: `${apiHost}/common/uploadTempPicByBinary`,
  // 查询部门详情
  API_FISHNET_GET_DEPT_INFO: `${apiHost}/dept/deptInfo`,
  // 查询子部门
  API_FISHNET_GET_SUB_DEPTS: `${apiHost}/dept/depts`,
  // 查询部门成员
  API_FISHNET_GET_DEPT_MEMBERS: `${apiHost}/dept/members`,
  // 获取成员基本信息(不含部门)
  API_FISHNET_GET_MEMBER_INFO: `${apiHost}/member/simpleInfoByTpId`,
  // 查询成员
  API_FISHNET_GET_MEMBERS_BY_KEY: `${apiHost}/member/list`,
  // 通过tpId获取成员标签
  API_FISHNET_GET_TPID_TAGS: `${apiHost}/tag/getMemberTagsByTpIds`,
  // 获取用户信息
  API_FISHNET_INFO_BY_IDS: `${apiHost}/member/simpleInfoByIds`,
  // 查询部门详细
  API_FISHNET_DEPTS_BY_IDS: `${apiHost}/dept/deptInfoByIds`,

  /** ******************** 考勤通讯录 **********************/
  // 获取标签统计
  API_SANDBOX_GET_TAG_STATISTICS: `${apiHost}/school/sandbox/groupTree/getAccommodationTagStatistics`,
  // 准备部门树
  API_SANDBOX_PREPARE: `${apiHost}/school/sandbox/groupTree/prepare`,
  // 创建选人组件沙盒
  API_SANDBOX_CREATE: `${apiHost}/school/sandbox/groupTree/create`,
  // 获取沙盒状态
  API_SANDBOX_GET_STSTUS: `${apiHost}/school/sandbox/groupTree/getStatus`,
  // 查树节点信息
  API_SANDBOX_GET_NODES: `${apiHost}/school/sandbox/groupTree/getSubNodes`,
  // 加部门筛选条件
  API_SANDBOX_SELECT_GROUPS: `${apiHost}/school/sandbox/groupTree/selectNodes`,
  // 移除部门筛选条件
  API_SANDBOX_UNSELECT_GROUPS: `${apiHost}/school/sandbox/groupTree/unselectNodes`,
  // 勾选
  API_SANDBOX_CHANGE_SELECTIONS: `${apiHost}/school/sandbox/groupTree/changeSelections`,
  // 选中单个学生
  API_SANDBOX_SELECT_ONE: `${apiHost}/school/sandbox/groupTree/selectOneStudent`,
  // 取消选中单个学生
  API_SANDBOX_UNSELECT_ONE: `${apiHost}/school/sandbox/groupTree/unselectOneStudent`,
  // 加已选学生
  API_SANDBOX_SELECT_STUDENTS: `${apiHost}/school/sandbox/groupTree/selectStudents`,
  // 移除已选学生
  API_SANDBOX_SELECT_UNSTUDENTS: `${apiHost}/school/sandbox/groupTree/unselectStudents`,
  // 清除所有已选择
  API_SANDBOX_CLEAR_ALL: `${apiHost}/school/sandbox/groupTree/unselectAll`,
  // 查询已选学生列表-有选项的班级列表
  API_SANDBOX_GET_CHECKED_CLASSES: `${apiHost}/school/sandbox/groupTree/getCheckedClasses`,
  // 查询已选学生列表-学生列表
  API_SANDBOX_GET_CHECKED_STUDENTS: `${apiHost}/school/sandbox/groupTree/getCheckedStudents`,
  // 修改选项-按班级学生
  API_SANDBOX_CHANGE_STUDENTS_SELECTIONS: `${apiHost}/school/sandbox/groupTree/changeClassStudentSelections`,
  // 修改选项-按部门
  API_SANDBOX_CHANGE_DEPTS_SELECTIONS: `${apiHost}/school/sandbox/groupTree/changeDeptSelections`,
  // 查班级下的学生列表及选中状态
  API_SANDBOX_GET_CLASSES_STUDENTS: `${apiHost}/school/sandbox/groupTree/getClassStudents`,
  // 搜索学生
  API_SANDBOX_SEARCH_STUDENTS: `${apiHost}/school/sandbox/groupTree/searchStudents`,
  // 提交预选项
  API_SANDBOX_COMMIT: `${apiHost}/school/sandbox/groupTree/commitPreSelections`,
  // 取消预选项
  API_SANDBOX_ROLLBACK: `${apiHost}/school/sandbox/groupTree/rollbackPreSelections`,
  // 查询沙盒变更概述
  API_SANDBOX_CHANGE_SUMMARY: `${apiHost}/school/sandbox/groupTree/getChangeSummary`,
  // 重置沙盒状态，当沙盒变更处理超时时，要调些接口
  API_SANDBOX_RESET: `${apiHost}/school/sandbox/groupTree/resetStatus`,
  /** ******************** 考勤通讯录 **********************/

  /** ******************** padbook **********************/
  /* 班级树 */
  // 通用班级树,修改选项-按部门
  API_CLASSTREE_CHANGESELECTION: `${apiHost}/squirrel/h5/classTree/changeSelection`,
  // 通用班级树,提交预选项
  API_CLASSTREE_COMMIT: `${apiHost}/squirrel/h5/classTree/commit`,
  // 创建树,班牌绑定范围
  API_CLASSTREE_CREATE: `${apiHost}/squirrel/h5/classTree/createClassPadBindingTree`,
  // 查询已选节点列表
  API_CLASSTREE_GET_SELECTNODES: `${apiHost}/squirrel/h5/classTree/getSelectedNodes`,
  // 通用班级树,取消预选项
  API_CLASSTREE_ROLLBACK: `${apiHost}/squirrel/h5/classTree/rollback`,
  // 通用班级树,查子节点
  API_CLASSTREE_SUBNODE: `${apiHost}/squirrel/h5/classTree/subNodes`,
  // 通用班级树,清空所有已选学生
  API_CLASSTREE_UNSELECT_ALL: `${apiHost}/squirrel/h5/classTree/unselectAll`,
  // 模糊匹配部门名字
  API_CLASSTREE_SEARCH: `${apiHost}/squirrel/h5/classTree/searchNodes`,
  // 通用班级树,批量取消预选项
  API_CLASSTREE_BATCH_ROLLBACK: `${apiHost}/squirrel/h5/classTree/batchRollback`,
  // 通用班级树,批量提交预选项
  API_CLASSTREE_BATCH_COMMIT: `${apiHost}/squirrel/h5/classTree/bathCommit`,
  /** ******************** padbook **********************/
  /** ******************** MUI **********************/
  // 查询根部门
  API_FISHNET_GET_ROOT_DEPT: `${apiHost}/dept/root`,
  // 获取成员标签
  API_FISHNET_GET_MEMBERS_TAGS: `${apiHost}/tag/listMemberOfTags`,
  // 获取机构标签list
  API_FISHNET_GET_TAG_LIST: `${apiHost}/tag/listTags`,

  /** ******************** MUI **********************/

  /** 机构通讯录沙盒 */
  // 创建沙盒
  API_ORG_SANDBOX_CREATE: `${apiHost}/school/sandbox/orgUser/create`,
  // 获取沙盒状态
  API_ORG_SANDBOX_STATUS: `${apiHost}/school/sandbox/orgUser/getStatus`,
  // 重置沙盒
  API_ORG_SANDBOX_STATUS_RESET: `${apiHost}/school/sandbox/orgUser/resetStatus`,
  // 获取已选人员
  API_ORG_SANDBOX_MEMBER_SELECT: `${apiHost}/school/sandbox/orgUser/getSelectedUsers`,
  // 查询子节点
  API_ORG_SANDBOX_SUBNODES: `${apiHost}/school/sandbox/orgUser/getSubNodes`,
  // 查询部门人员列表
  API_ORG_SANDBOX_MEMBER: `${apiHost}/school/sandbox/orgUser/queryDeptUsers`,
  // 选择部门
  API_ORG_SANDBOX_SELECT_DEPT: `${apiHost}/school/sandbox/orgUser/selectDepts`,
  // 选择人员
  API_ORG_SANDBOX_SELECT_MEMBER: `${apiHost}/school/sandbox/orgUser/selectUsers`,
  // 取消选择部门
  API_ORG_SANDBOX_UNSELECT_DEPT: `${apiHost}/school/sandbox/orgUser/unselectDepts`,
  // 取消选中人员
  API_ORG_SANDBOX_UNSELECT_MEMBER: `${apiHost}/school/sandbox/orgUser/unselectUsers`,
  // 取消预选项
  API_ORG_SANDBOX_ROLLBACK: `${apiHost}/school/sandbox/orgUser/rollback`,
  // 提交预选项
  API_ORG_SANDBOX_COMMIT: `${apiHost}/school/sandbox/orgUser/commit`,
  // 清空所有已选学生
  API_ORG_SANDBOX_CLEAR_MEMBER: `${apiHost}/school/sandbox/orgUser/unselectAll`,
  // 沙盒搜索学生
  API_ORG_SANDBOX_SEARCH: `${apiHost}/school/sandbox/orgUser/searchUsers`,
  // 模糊搜索部门列表
  API_ORG_SEARCH_DEPTIDS: `${apiHost}/school/sandbox/orgUser/searchDeptIds`,
  // 按姓名模糊搜索员工
  API_SEARCH_ORG_MEMBER: `${apiHost}/squirrel/common/searchOrgMember`
  /** 机构通讯录沙盒 */
}
